var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericBank = function SvgGenericBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#generic_bank_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.566 16.218 20 11l-9.566 5.218.4 1.565H12.5v6.666h-.833v1.667h16.666v-1.667H27.5v-6.666h1.667l.399-1.565Zm-15.4 8.231v-6.666h2.5v6.666h-2.5Zm4.167 0v-6.666h3.334v6.666h-3.334Zm5 0v-6.666h2.5v6.666h-2.5ZM20 12.9l5.899 3.217H14.1l5.9-3.217ZM10 28.616h20v-1.667H10v1.667Z",
    fill: "#1D1737"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#F1F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "generic_bank_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })))));
};
export default SvgGenericBank;